var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStart28 = function SvgIconStart28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.523a.6.6 0 0 1 .6.6v7.844l6.897-3.927a.6.6 0 1 1 .593 1.043l-6.879 3.915 6.88 3.917a.6.6 0 0 1-.594 1.043L12.6 13.03v7.843a.6.6 0 1 1-1.2 0V13.03l-6.898 3.928a.6.6 0 0 1-.593-1.043l6.877-3.917L3.91 8.083a.6.6 0 0 1 .593-1.043l6.899 3.927V3.123a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgIconStart28;